// extracted by mini-css-extract-plugin
export var blub = "_28qey";
export var buttonsContainer = "ZjQyU";
export var description = "Y2Coi";
export var icon = "Mzetp";
export var iconContainer = "oo6yU";
export var root = "_5Bg11";
export var textWrapper = "A9sh6";
export var title = "_3e4Bh";